import script from "./cnt-license.vue?vue&type=script&lang=ts&setup=true"
export * from "./cnt-license.vue?vue&type=script&lang=ts&setup=true"

import "./cnt-license.vue?vue&type=style&index=0&id=69d63a20&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d63a20"]])

export default __exports__